import { ActionType } from "../../actions/ActionType";
import { Action } from "../../actions/event/FreelancerSchedulingActions";

interface FreelancerSchedulingState {
    isLoading: boolean;
    error: string | null;
    personnelType: {
        personnelType: string;
        personnelTypeDescription: string;
    }[];
}

const initialState = {
    isLoading: false,
    error: null,
    personnelType: [],
};

const freelancerSchedulingReducer = (
    state: FreelancerSchedulingState = initialState,
    action: Action
) => {
    switch (action.type) {
        case ActionType.FETCH_PERSONNEL_TYPE_LIST_START:
            return {
                isLoading: true,
                error: null,
                personnelType: state.personnelType,
            };
        case ActionType.FETCH_PERSONNEL_TYPE_LIST_SUCCESS:
            return {
                isLoading: false,
                error: null,
                personnelType: action.payload,
            };
        case ActionType.FETCH_PERSONNEL_TYPE_LIST_ERROR:
            return {
                isLoading: false,
                error: action.payload,
                personnelType: state.personnelType,
            };
        default:
            return state;
    }
};

export default freelancerSchedulingReducer;
